module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app-layout', [_c('v-bloc', [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('v-section-header', {
    attrs: {
      "type": "files"
    }
  }, [_vm._v("\n          Tuo tiedostoja\n        ")]), _vm._v(" "), _c('dropzone', {
    ref: "myDropzone",
    attrs: {
      "id": "innerFilesDropzone",
      "options": _vm.dropzoneOptions,
      "destroyDropzone": false
    },
    on: {
      "vdropzone-removed-file": _vm.removeFile,
      "vdropzone-mounted": _vm.mountFiles,
      "vdropzone-success": _vm.showSuccess,
      "vdropzone-sending": _vm.sendingEvent
    }
  }, [_c('input', {
    attrs: {
      "type": "hidden",
      "name": "quoteId"
    },
    domProps: {
      "value": _vm.$store.state.route.params.quoteId
    }
  })]), _vm._v(" "), _c('v-nav-footer', {
    attrs: {
      "prevRoute": "inner-basics.index",
      "nextRoute": "inner-preview.index",
      "routeParams": {
        projectId: _vm.$store.state.route.params.projectId
      }
    }
  })], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-3185b7f9"}!./src/app/pages/inner-files/inner-files.html
// module id = 468
// module chunks = 1